import React from "react";


export const HomeView = (props) => {
  return (
    <div></div>
  );
};
